import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "p-col-12 p-md-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Adı"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1)
const _hoisted_4 = { class: "p-col-12 p-md-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Aktif")
], -1)

import { defineComponent, ref, computed, h, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import Checkbox from "primevue/checkbox";


export default /*#__PURE__*/_defineComponent({
  __name: 'Add',
  setup(__props) {

const toast = useToast();
const submitButton = ref<HTMLElement | null>(null);
const store = useStore();
const isActive = ref(false);
const active = ref(true);
const orderTypeName = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
};
const saveChanges = () => {
  var model = {
    name: orderTypeName.value,
    isActive: active.value,
  };
  store.dispatch(Actions.ADD_ORDERTYPE, model).then((x) => {
    if (x.success) {
      toast.add({
        severity: "success",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      store.dispatch(Actions.ORDERTYPE_LIST);
      location.reload();
    } else {
      toast.add({
        severity: "error",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-light-primary",
      onClick: toggleModal,
      style: {"border":"1px solid #eee"}
    }, " Yeni Oluştur "),
    _createVNode(Modal, {
      onClose: toggleModal,
      modalActive: isActive.value,
      title: "Sipariş Tipi Ekle",
      width: "75vw"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Kaydet",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (saveChanges())),
          icon: "pi pi-check",
          autofocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(Field), {
              type: "text",
              class: "form-control form-control-solid",
              placeholder: "",
              name: "orderTypeName",
              modelValue: orderTypeName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderTypeName).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(Checkbox), {
              id: "binary",
              modelValue: active.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
              binary: true
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modalActive"])
  ], 64))
}
}

})